var hostScrollSnapshot;
/** Keeps the merchant page stationary while the SDK-owned payment sheet is open. */
export var lockPaymentSheetHostScroll = function () {
    if (hostScrollSnapshot || !document.body || !document.documentElement)
        return;
    var body = document.body;
    var scrollX = window.scrollX || window.pageXOffset || 0;
    var scrollY = window.scrollY || window.pageYOffset || 0;
    hostScrollSnapshot = {
        bodyLeft: body.style.left,
        bodyPosition: body.style.position,
        bodyTop: body.style.top,
        bodyWidth: body.style.width,
        scrollX: scrollX,
        scrollY: scrollY,
    };
    body.style.position = "fixed";
    body.style.top = "".concat(-scrollY, "px");
    body.style.left = "".concat(-scrollX, "px");
    body.style.width = "100%";
};
/** Restores the merchant styles and the exact page position captured on open. */
export var unlockPaymentSheetHostScroll = function () {
    if (!hostScrollSnapshot || !document.body || !document.documentElement)
        return;
    var snapshot = hostScrollSnapshot;
    hostScrollSnapshot = undefined;
    document.body.style.position = snapshot.bodyPosition;
    document.body.style.top = snapshot.bodyTop;
    document.body.style.left = snapshot.bodyLeft;
    document.body.style.width = snapshot.bodyWidth;
    window.scrollTo(snapshot.scrollX, snapshot.scrollY);
};
